import {
	GetPlayerWithDepositRequest,
	GetPlayerWithDepositResponse,
} from '@/modules/manage-player/type'
import { UseBaseQueryOptions } from '@tanstack/react-query'
import { useQuery } from '@tanstack/react-query'
import { getPlayerWithDeposit } from '../../services'
import { PlayerQueryKeys } from '@/modules/manage-player/keys'

export default function useQueryGetPlayerWithDeposit(
	payload: GetPlayerWithDepositRequest,
	props?: UseBaseQueryOptions<GetPlayerWithDepositResponse>,
) {
	return useQuery({
		queryKey: [PlayerQueryKeys.GetPlayerWithDeposit, payload],
		queryFn: () => getPlayerWithDeposit(payload),
		...props,
	})
}
